import React from 'react';
import Icon from './Icon';

const OfficeIcon = (props) => (
    <Icon {...props}>
        <path d="M3 21H21" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M19 21V15V7C19 5.11438 19 4.17157 18.4142 3.58579C17.8284 3 16.8856 3 15 3H12H9C7.11438 3 6.17157 3 5.58579 3.58579C5 4.17157 5 5.11438 5 7V15V21" strokeLinejoin="round" />
        <path d="M9 8L10 8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 12L10 12" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 16L10 16" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 8L15 8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 12L15 12" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M14 16L15 16" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
);

export default OfficeIcon;